import { Icon as OrigIcon, colors, iconSizes, mixin } from "@hubrise/react-components"
import styled from "styled-components"

const Icon = styled(OrigIcon)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.textDark};
  transition: visibility 0.1s;
  visibility: hidden;
  ${mixin.clickable};
`

export const DeleteIcon = styled(Icon).attrs({ code: "delete", size: iconSizes._20, testId: "delete-icon" })``

export const MoveIcon = styled(Icon).attrs({ code: "drag_indicator", size: iconSizes._20, testId: "move-icon" })``
